<template>
  <div class="content">
    <template>
      <div class="content">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <card>
                <template slot="header">
                  <h4 class="card-title">CRM</h4>
                </template>

                <vue-tabs
                  textPosition="center"
                  :centered="true"
                  class="crm-tabs"
                >
                  <v-tab title="Leads">
                    <div class="ml-3 mb-4 mt-2">
                      <label for="perfil" class="mb-3">Filtros</label>
                      <div class="d-flex flex-column flex-sm-row">
                        <div
                          class="d-flex mr-0 mr-sm-3 mb-2 mb-sm-0"
                          v-if="isColaborador"
                        >
                          <base-checkbox
                            v-model="leadFiltros.todosVendedores"
                            :inline="true"
                            class="align-items-center d-flex"
                          />
                          <label
                            for="todosVendedores"
                            class="d-flex align-items-center mb-0"
                          >
                            Todos os vendedores
                          </label>
                        </div>
                        <div
                          class="d-flex mr-0 mr-sm-3 mb-2 mb-sm-0 align-self-center"
                        >
                          <div class="d-flex pr-2 align-items-center">
                            <label for="perfil">Id</label>
                          </div>
                          <input
                            v-model="leadFiltros.id"
                            class="form-control"
                          />
                        </div>
                        <div
                          class="d-flex mr-0 mr-sm-5 mb-4 mb-sm-0 align-self-center"
                        >
                          <label
                            for="ativo"
                            class="d-flex align-items-center mb-0 pr-2"
                            >Nome</label
                          >
                          <input
                            v-model="leadFiltros.nome"
                            class="form-control"
                          />
                        </div>
                        <div class="d-flex">
                          <button
                            @click="loadList()"
                            class="btn btn-success mr-2"
                          >
                            Filtrar
                          </button>
                          <button
                            @click="limparFiltrosEBuscarLista()"
                            class="btn btn-danger"
                          >
                            Limpar filtros
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="overflow-auto">
                      <l-table
                        class="table-hover table-striped"
                        :columns="dataTable.columns"
                        :data="dataTable.data"
                      >
                        <template slot-scope="{ row }">
                          <td>
                            <b>{{ row.codigo }}</b>
                          </td>
                          <td>
                            {{ row.nome }}
                            <i
                              v-if="isBefore(row.dataLembrete)"
                              class="fa fa-exclamation text-danger"
                            ></i>
                          </td>
                          <td v-if="dataTable.columns.includes('Vendedor')">
                            {{
                              row.emissor.nome
                                ? `${row.emissor.nome} ${row.emissor.sobrenome}`
                                : row.emissor.razaoSocial
                            }}
                          </td>
                          <td>
                            <button
                              class="btn btn-icon btn-warning"
                              style="margin-right: 10px"
                              @click="openModalLembrete(row)"
                            >
                              <i class="fa fa-bell" aria-hidden="true"></i>
                            </button>
                            <router-link :to="`crm/${row.codigo}`">
                              <button
                                class="btn btn-icon btn-info"
                                style="margin-right: 10px"
                                @click="editar(row)"
                              >
                                <i class="fa fa-pencil"></i>
                              </button>
                            </router-link>
                            <button
                              class="btn btn-icon btn-success"
                              style="margin-right: 10px"
                              @click="openModalConverter(row)"
                            >
                              <i class="fa fa-paper-plane "></i>
                            </button>
                            <button
                              class="btn btn-icon btn-danger"
                              @click="openModalDeletar(row)"
                            >
                              <i class="fa fa-trash-o"></i>
                            </button>
                          </td>
                        </template>
                      </l-table>
                    </div>
                    <v-pagination
                      v-if="dataTable.data.length > 0"
                      v-model="currentPage"
                      :page-count="totalPages"
                      :classes="bootstrapPaginationClasses"
                      :labels="paginationAnchorTexts"
                    ></v-pagination>
                  </v-tab>

                  <v-tab title="Estatísticas">
                    <div class="ml-3 mb-4 mt-2">
                      <label for="perfil" class="mb-3">Filtros</label>
                      <div class="d-flex flex-column flex-sm-row">
                        <div
                          class="d-flex mr-0 mr-sm-3 mb-2 mb-sm-0"
                          v-if="isColaborador"
                        >
                          <base-checkbox
                            v-model="estatisticasFiltros.todosVendedores"
                            :inline="true"
                            class="align-items-center d-flex"
                          />
                          <label
                            for="todosVendedores"
                            class="d-flex align-items-center mb-0"
                          >
                            Todos os vendedores
                          </label>
                        </div>
                        <div
                          class="d-flex mr-0 mr-sm-3 mb-2 mb-sm-0 align-self-center"
                        >
                          <div class="d-flex pr-2 align-items-center">
                            <label for="perfil" class="m-0">Mês</label>
                          </div>
                          <date-picker
                            format="MMMM/YYYY"
                            v-model="estatisticasFiltros.mes"
                            type="month"
                            :disabled-date="disabledDateDatepickerEstatistica"
                          ></date-picker>
                        </div>
                        <div
                          class="d-flex mr-0 mr-sm-5 mb-4 mb-sm-0 align-self-center"
                          v-if="isColaborador"
                        >
                          <label
                            for="ativo"
                            class="d-flex align-items-center mb-0 pr-2"
                            >Vendedor</label
                          >
                          <multiselect
                            v-model="estatisticasFiltros.usuario"
                            :options="listaVendedoresEColaboradores"
                            placeholder=""
                            :showLabels="false"
                            :customLabel="codigoENome"
                            :disabled="estatisticasFiltros.todosVendedores"
                            class="usuario-multiselect"
                          >
                            <span slot="noResult">Não encontrado</span>
                          </multiselect>
                        </div>
                        <div class="d-flex">
                          <button
                            @click="loadEstatisticas()"
                            class="btn btn-success mr-2"
                          >
                            Filtrar
                          </button>
                          <button
                            @click="limparFiltrosEBuscarEstatisticas()"
                            class="btn btn-danger"
                          >
                            Limpar filtros
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="small">
                      <p class="text-center" v-show="estatisticas">
                        {{ tituloGrafico }}
                      </p>
                      <pie-chart
                        v-show="estatisticas"
                        :chart-data="estatisticas"
                        :options="opcoesGraficoEstatisticas"
                      ></pie-chart>
                      <p class="text-center" v-if="!estatisticas">
                        Não há registros para os filtros selecionados.
                      </p>
                    </div>
                  </v-tab>
                </vue-tabs>
              </card>
            </div>
          </div>
        </div>
      </div>
    </template>
    <Modal
      header="Deseja realmente excluir o lead?"
      :hasBody="true"
      v-show="isVisibleModalDeletar"
      @close="closeModalDeletar"
      :hasDeleteButton="true"
      :deleteFunction="deletarLead"
    >
      <template v-slot:body>
        Esta ação é definitiva e não poderá ser desfeita.
      </template>
    </Modal>
    <Modal
      header="Deseja realmente converter o lead para cliente?"
      :hasBody="true"
      v-show="isVisibleModalConverter"
      @close="closeModalConverter"
    >
      <template v-slot:body>
        Esta ação é definitiva e não poderá ser desfeita.
      </template>
      <template v-slot:actions>
        <button
          type="button"
          class="btn btn-success"
          @click.prevent
          @click="converter()"
        >
          Converter
        </button>
      </template>
    </Modal>
    <Modal
      :header="`Lembrete para ${this.leadSelecionado.nome}`"
      v-show="isVisibleModalLembrete"
      :hasBody="true"
      @close="closeModalLembrete"
    >
      <template v-slot:body>
        <div class="row mb-3">
          <div class="col-md-6">
            <label class="">Data*</label>
            <date-picker
              format="DD/MM/YYYY"
              v-model="dataLembrete"
              :disabled-date="disabledDateDatepickerDataLembrete"
            ></date-picker>
          </div>
        </div>

        <base-input
          type="textarea"
          label="Mensagem*"
          v-model="mensagemLembrete"
        ></base-input>
      </template>
      <template v-slot:actions>
        <button
          type="button"
          class="btn btn-success"
          @click.prevent
          @click="salvarLembrete()"
        >
          Salvar
        </button>
      </template>
    </Modal>
  </div>
</template>
<script>
import _ from 'lodash';
import { VueTabs, VTab } from 'vue-nav-tabs';
import LTable from 'src/components/Table';
import DatePicker from 'vue2-datepicker';
import CrmService from 'src/services/crm';
import vPagination from 'vue-plain-pagination';
import VueToggles from 'vue-toggles';
import isBefore from 'date-fns/isBefore';
import isAfter from 'date-fns/isAfter';
import subDays from 'date-fns/subDays';
import Multiselect from 'vue-multiselect';
import Modal from 'src/components/Modal';
import PieChart from 'src/components/PieChart';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/pt-br';
import 'vue-nav-tabs/themes/vue-tabs.css';

const VUE_APP_SPINNER_COLOR = process.env.VUE_APP_SPINNER_COLOR;

const colunas = ['ID', 'Nome'];
const colunasComVendedor = ['ID', 'Nome', 'Vendedor'];
export default {
  components: {
    LTable,
    vPagination,
    VueToggles,
    Modal,
    DatePicker,
    VueTabs,
    VTab,
    PieChart,
    Multiselect
  },
  mounted() {
    this.loadEstatisticas();
  },
  data() {
    return {
      dataTable: {
        columns: [],
        data: []
      },
      isVisibleModalDeletar: false,
      isVisibleModalLembrete: false,
      isVisibleModalConverter: false,
      leadSelecionado: {},
      currentPage: 1,
      totalPages: Number,
      bootstrapPaginationClasses: {
        ul: 'pagination',
        li: 'page-item',
        liActive: 'active',
        liDisable: 'disabled',
        button: 'page-link btn-info'
      },
      paginationAnchorTexts: {
        first: 'Primeira',
        prev: '<',
        next: '>',
        last: 'Última'
      },
      leadFiltros: {
        nome: '',
        id: '',
        todosVendedores: false
      },
      estatisticasFiltros: {
        usuario: undefined,
        mes: new Date(),
        todosVendedores: false
      },
      dataLembrete: null,
      mensagemLembrete: '',
      estatisticas: null,
      opcoesGraficoEstatisticas: {
        legend: {
          labels: {
            fontSize: 15,
            boxWidth: 30,
            padding: 20
          }
        },
        tooltips: {
          titleFontSize: 14,
          custom: this.customTooltipGraficoEstatisticas
        }
      },
      listaVendedoresEColaboradores: [
        { name: 'Vue.js', language: 'JavaScript' },
        { name: 'Rails', language: 'Ruby' },
        { name: 'Sinatra', language: 'Ruby' },
        { name: 'Laravel', language: 'PHP' },
        { name: 'Phoenix', language: 'Elixir' }
      ]
    };
  },
  created() {
    this.loadList();
    this.dataTable.columns = colunas;
    if (this.isColaborador) {
      this.loadColaboradoresEVendedores();
    }
  },
  computed: {
    isColaborador() {
      const userData = this.$store.state.usuario;
      return _.get(userData, 'tipoUsuario') === 'colaborador';
    }
  },
  methods: {
    customTooltipGraficoEstatisticas(tooltipModel) {
      if (_.get(tooltipModel, 'body[0].lines')) {
        if (_.get(this, 'estatisticas.datasets[0].data')) {
          const total = this.estatisticas.datasets[0].data.reduce(
            (prev, curr) => prev + curr,
            0
          );
          let itemIndex;
          let negociacaoTooltip = false;
          const textoAtual = tooltipModel.body[0].lines[0].toLocaleLowerCase();
          if (textoAtual.includes('convertidas')) {
            itemIndex = 0;
          } else if (textoAtual.includes('negociação')) {
            itemIndex = 1;
            negociacaoTooltip = true;
          } else if (textoAtual.includes('desistidos')) {
            itemIndex = 2;
          }
          const valorItem = this.estatisticas.datasets[0].data[itemIndex];
          const labelItem = this.estatisticas.labels[itemIndex];
          tooltipModel.body[0].lines = [
            ` ${valorItem} ${
              negociacaoTooltip
                ? 'em negociação'
                : labelItem.toLocaleLowerCase()
            } - ${((valorItem / total) * 100).toFixed(1)}%`
          ];
          tooltipModel.width = negociacaoTooltip ? 170 : 155;
        }
      }
    },
    loadList() {
      const loader = this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });
      const params = {
        page: this.currentPage,
        nome: this.leadFiltros.nome,
        id: this.leadFiltros.id,
        todosVendedores: this.leadFiltros.todosVendedores
      };
      CrmService.listar(params)
        .then(response => {
          this.totalItens = _.get(response, 'data.count');
          this.totalPages = Math.ceil(this.totalItens / 10);
          this.dataTable.data = _.get(response, 'data.result');
          if (params.todosVendedores) {
            this.dataTable.columns = colunasComVendedor;
          } else {
            this.dataTable.columns = colunas;
          }
          loader.hide();
        })
        .catch(error => {
          loader.hide();
          this.showError(error);
        });
    },
    loadColaboradoresEVendedores() {
      CrmService.listarUsuariosComDados().then(response => {
        this.listaVendedoresEColaboradores = response.data;
      });
    },
    loadEstatisticas() {
      if (!this.estatisticasFiltros.mes) {
        this.notifyVue(
          'top',
          'center',
          'info',
          'Selecione um mês',
          'fa fa-info'
        );
        return;
      }
      const loader = this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });
      const params = {
        mes: this.estatisticasFiltros.mes,
        id:
          this.estatisticasFiltros.usuario &&
          this.estatisticasFiltros.usuario.id,
        todosVendedores: this.estatisticasFiltros.todosVendedores
      };
      const successCallback = response => {
        this.atualizarEstatisticas(response.data);
        loader.hide();
      };
      CrmService.resumo(params)
        .then(successCallback)
        .catch(error => {
          loader.hide();
          this.showError(error);
        });
    },
    limparFiltrosEBuscarEstatisticas() {
      this.estatisticasFiltros = {
        mes: new Date(),
        todosVendedores: false,
        usuario: undefined
      };
      this.loadEstatisticas();
    },
    atualizarEstatisticas(data) {
      if (
        data.convertidas === 0 &&
        data.negociacao === 0 &&
        data.desistido === 0
      ) {
        this.estatisticas = undefined;
      } else {
        this.estatisticas = {
          labels: ['Convertidas', 'Negociação', 'Desistidos'],
          datasets: [
            {
              label: 'vendedor 1',
              backgroundColor: ['orange', 'blue', 'gray'],
              data: [data.convertidas, data.negociacao, data.desistido]
            }
          ]
        };
        let mes = this.estatisticasFiltros.mes.toLocaleString('pt-br', {
          month: 'long'
        });
        mes = `${mes[0].toLocaleUpperCase()}${mes.substring(1)}`;
        let nomeUsuario;
        if (this.isColaborador) {
          if (this.estatisticasFiltros.todosVendedores) {
            nomeUsuario = 'Todos os vendedores';
          } else if (this.estatisticasFiltros.usuario) {
            nomeUsuario = this.codigoENome(this.estatisticasFiltros.usuario);
          } else {
            nomeUsuario = 'Você';
          }
        }
        let title = `${mes}/${this.estatisticasFiltros.mes.getFullYear()}`;
        if (nomeUsuario) {
          title += ` - ${nomeUsuario}`;
        }
        this.tituloGrafico = title;
      }
    },
    showError(error) {
      const message =
        _.get(error, 'response.status') === 400 &&
        _.has(error, 'response.data.message')
          ? _.get(error, 'response.data.message')
          : 'Ocorreu algum erro interno. Tente novamente mais tarde.';

      this.notifyVue(
        'top',
        'center',
        'danger',
        message,
        'fa fa-exclamation-triangle'
      );
    },
    openModalDeletar(row) {
      this.isVisibleModalDeletar = true;
      this.leadSelecionado = row;
    },
    closeModalDeletar() {
      this.isVisibleModalDeletar = false;
      this.leadSelecionado = {};
    },
    openModalConverter(row) {
      this.isVisibleModalConverter = true;
      this.leadSelecionado = row;
    },
    notifyVue(verticalAlign, horizontalAlign, type, message, icon) {
      this.$notifications.notify({
        message: `<span>${message}</span>`,
        icon: icon,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type
      });
    },
    deletarLead() {
      const loader = this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });

      const sucessCallback = () => {
        this.notifyVue(
          'top',
          'center',
          'success',
          'Deletado com Sucesso.',
          'fa fa-check'
        );
        this.closeModalDeletar();
        this.loadList();
        this.loadEstatisticas();
        loader.hide();
      };

      const errorCallback = err => {
        this.closeModalDeletar();
        loader.hide();
        this.showError(err);
      };

      CrmService.deletar(this.leadSelecionado)
        .then(sucessCallback)
        .catch(errorCallback);
    },
    limparFiltrosEBuscarLista() {
      this.leadFiltros = {
        estado: '',
        ativo: false
      };
      this.loadList();
    },
    closeModalLembrete() {
      this.isVisibleModalLembrete = false;
      setTimeout(() => {
        this.leadSelecionado = {};
        this.dataLembrete = null;
        this.mensagemLembrete = '';
      }, 500);
    },
    closeModalConverter() {
      this.isVisibleModalConverter = false;
      this.leadSelecionado = {};
    },
    openModalLembrete(row) {
      this.leadSelecionado = row;
      if (row.dataLembrete) {
        this.dataLembrete = new Date(row.dataLembrete);
      }
      if (row.mensagemLembrete) {
        this.mensagemLembrete = row.mensagemLembrete;
      }
      this.isVisibleModalLembrete = true;
    },
    salvarLembrete() {
      const loader = this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });
      if (!this.isValidLembreteEdition()) {
        this.notifyVue(
          'top',
          'center',
          'danger',
          'Preencha todos os campos para salvar o lembrete',
          'fa fa-exclamation-triangle'
        );
        loader.hide();
        return;
      }
      const sucessCallback = () => {
        this.notifyVue(
          'top',
          'center',
          'success',
          'Lembrete adicionado com sucesso.',
          'fa fa-check'
        );
        this.closeModalLembrete();
        this.loadList();
        loader.hide();
      };

      const errorCallback = err => {
        this.notifyVue(
          'top',
          'center',
          'danger',
          err,
          'fa fa-exclamation-triangle'
        );
        this.closeModalLembrete();
        loader.hide();
      };

      CrmService.atualizarDataLembrete(
        this.leadSelecionado._id,
        this.dataLembrete,
        this.mensagemLembrete
      )
        .then(sucessCallback)
        .catch(errorCallback);
    },
    isValidLembreteEdition() {
      if (this.dataLembrete !== null && this.mensagemLembrete !== '') {
        return true;
      }
      return false;
    },
    disabledDateDatepickerDataLembrete(date) {
      const ontem = subDays(Date.now(), 1);
      return isBefore(date, ontem);
    },
    disabledDateDatepickerEstatistica(date) {
      return isAfter(date, Date.now());
    },
    isBefore(dataLembreteString) {
      if (!dataLembreteString) {
        return false;
      }
      const dataLembrete = new Date(dataLembreteString);
      return isBefore(dataLembrete, Date.now());
    },
    codigoENome(user) {
      return `${user.codigo} ${
        user.nome ? `${user.nome} ${user.sobrenome}` : user.razaoSocial
      }`;
    },
    converter() {
      const loader = this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });

      const sucessCallback = () => {
        this.notifyVue(
          'top',
          'center',
          'success',
          'Convertido com sucesso.',
          'fa fa-check'
        );
        this.closeModalConverter();
        this.loadList();
        this.loadEstatisticas();
        loader.hide();
      };

      const errorCallback = err => {
        this.closeModalConverter();
        loader.hide();
        this.showError(err);
      };

      CrmService.converter(this.leadSelecionado._id)
        .then(sucessCallback)
        .catch(errorCallback);
    }
  },
  watch: {
    currentPage: function(newValue, oldValue) {
      if (this.currentPage !== oldValue) {
        this.loadList();
      }
    }
  }
};
</script>
<style>
.crm-tabs .nav {
  display: block !important;
}
.small {
  max-width: 600px;
  margin: auto;
}
.usuario-multiselect {
  min-width: 12em;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
